(function () {
  const sectionSel = '[class="ctabs section featured_col"]';
  const BP_SM = 720; // <990 = mobile

  /* ================== Helpers base ================== */
  function debounce(fn, wait){ let t; return function(){ clearTimeout(t); t=setTimeout(()=>fn.apply(this,arguments), wait); }; }

  function setupTabs(section) {
    const tabs = Array.from(section.querySelectorAll('.ctabs__tab'));
    const panels = Array.from(section.querySelectorAll('.ctabs__panel'));
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => { t.classList.remove('is-active'); t.setAttribute('aria-selected','false'); });
        panels.forEach(p => p.classList.remove('is-active'));
        tab.classList.add('is-active'); tab.setAttribute('aria-selected','true');
        const panel = panels[i]; panel.classList.add('is-active');
        initTrack(panel, /*force*/ true);

        const sectionNode = tab.closest('[data-section-id]');
        document.dispatchEvent(new CustomEvent('shopify:section:load', {
          bubbles: true, detail: { sectionId: sectionNode?.dataset.sectionId || '' }
        }));
      });
    });
    panels.forEach((p, idx) => { if (idx === 0) initTrack(p, true); });
  }

  /* ================== LÓGICA SLIDER (solo movimiento) ================== */
  function initTrack(panel, force) {
    const track = panel.querySelector('[data-track]');
    if (!track) return;
    if (track.dataset.ready && !force) return;
    track.dataset.ready = "1";

    const prev = panel.querySelector('.ctabs__prev');
    const next = panel.querySelector('.ctabs__next');
    const dotsWrap = panel.querySelector('[data-dots]');

    // Snap consistente
    track.style.scrollSnapType = track.style.scrollSnapType || 'x mandatory';
    track.style.scrollSnapStop = track.style.scrollSnapStop || 'always';

    const items = () => Array.from(track.querySelectorAll('.ctabs__item'));

    function gapPx() {
      const cs = getComputedStyle(track);
      return parseFloat(cs.columnGap || cs.gap || 16) || 0;
    }

    // Guardar ancho natural la primera vez (lo dejamos igual aunque ya no lo usemos para limitar)
    function ensureBaseCardW() {
      if (track.dataset.baseCardW) return parseFloat(track.dataset.baseCardW);
      const first = items()[0];
      if (!first) return 0;
      const w = first.getBoundingClientRect().width || 0;
      track.dataset.baseCardW = String(Math.round(w));
      return w;
    }

    // === MODIFICADO: forzar EXACTAMENTE 4 por vista en no-mobile ===
    function applyUniformCardWidth() {
      const its = items();
      if (!its.length) return 0;

      const isMobile = window.innerWidth < BP_SM;

      if (isMobile) {
        // En móvil: 1 por vista, limpia overrides
        its.forEach(el => {
          el.style.flex = ''; el.style.minWidth = ''; el.style.maxWidth = ''; el.style.width = '';
        });
        track.style.paddingRight = '';
        return 1;
      }

      const per = 4; // <<< EXACTAMENTE 4 POR VISTA EN NO-MOBILE
      const cs = getComputedStyle(track);
      const padL = parseFloat(cs.paddingLeft)||0;
      const padR = parseFloat(cs.paddingRight)||0;
      const content = Math.max(1, track.clientWidth - padL - padR); // ancho útil del carril
      const g = gapPx();

      // Cálculo exacto: 4 tarjetas + 3 gaps
      // Ejemplo con tu ancho 1470px y gap 24px => cardW = floor((1470 - 3*24) / 4) = 349px
      const totalGaps = (per - 1) * g;
      let cardW = Math.floor((content - totalGaps) / per);

      // Tolerancia: evita que un redondeo permita "asomar" una 5ª tarjeta
      if (cardW * per + totalGaps > content) {
        cardW = Math.max(1, cardW - 1);
      }

      its.forEach(el => {
        el.style.flex = `0 0 ${cardW}px`;
        el.style.minWidth = `${cardW}px`;
        el.style.maxWidth = `${cardW}px`;
        el.style.width = `${cardW}px`;
      });

      // Padding de cola para aterrizar exacto al final sin media tarjeta visible
      const used = per * cardW + totalGaps;
      const pr = Math.max(0, Math.round(content - used));
      track.style.paddingRight = pr + 'px';

      return per;
    }

    function leftAtIndex(i){
      const its = items(); if (!its.length) return 0;
      const firstLeft = its[0].offsetLeft;
      const idx = Math.max(0, Math.min(i, its.length - 1));
      return Math.max(0, Math.round(its[idx].offsetLeft - firstLeft));
    }

    function buildPages(){
      const its = items();
      const total = its.length;
      const per = (window.innerWidth < BP_SM) ? 1 : 4; // << grupos de 4
      if (!total) return [0];

      const pages = [];
      const groups = Math.max(1, Math.ceil(total / per));
      const lastStart = Math.max(0, total - per);

      for (let g = 0; g < groups; g++){
        const startIdx = Math.min(g * per, lastStart);
        pages.push(leftAtIndex(startIdx)); // 0, 4, 8... (último aterriza exacto)
      }
      // Dedup
      const uniq = [];
      pages.forEach(x => { if (!uniq.length || uniq[uniq.length-1] !== x) uniq.push(x); });
      return uniq.length ? uniq : [0];
    }

    // Navegación / dots
    let PAGES = [];
    function gotoPage(i, behavior='smooth'){
      const idx = Math.max(0, Math.min(i, PAGES.length - 1));
      track.scrollTo({ left: PAGES[idx], behavior });
    }
    function nearestPageIndex(){
      if (!PAGES.length) return 0;
      const x = track.scrollLeft;
      let best = 0, bestDiff = Infinity;
      for (let i = 0; i < PAGES.length; i++){
        const d = Math.abs(PAGES[i] - x);
        if (d < bestDiff){ best = i; bestDiff = d; }
      }
      return best;
    }
    function renderDots(activeIdx = 0){
      dotsWrap.innerHTML = '';
      PAGES.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        if (i === activeIdx) b.classList.add('is-active');
        b.addEventListener('click', () => gotoPage(i));
        dotsWrap.appendChild(b);
      });
      requestAnimationFrame(() => document.dispatchEvent(
        new CustomEvent('ctabs:dots:rendered', { detail: { panel } })
      ));
    }
    function updateActiveDot(){
      const idx = nearestPageIndex();
      dotsWrap.querySelectorAll('button').forEach((b, i) => b.classList.toggle('is-active', i === idx));
    }

    // Drag seguro
    function enableDragScroll(el){
      let isDragging=false, startX=0, startScroll=0, moved=0;
      const TH=8;
      el.addEventListener('pointerdown',(e)=>{
        const interactive = e.target.closest('a,button,input,textarea,select,summary,[role="button"],[data-no-drag],form');
        if (interactive) { isDragging=false; moved=0; return; }
        if (e.pointerType==='mouse' && e.button!==0) return;
        isDragging=true; moved=0; startX=e.clientX; startScroll=el.scrollLeft;
        el.setPointerCapture?.(e.pointerId); el.classList.add('is-dragging');
      });
      el.addEventListener('pointermove',(e)=>{
        if(!isDragging) return;
        const dx=e.clientX-startX; moved=Math.max(moved,Math.abs(dx)); el.scrollLeft=startScroll-dx;
      },{passive:true});
      function end(){ if(!isDragging) return; isDragging=false; el.classList.remove('is-dragging'); }
      el.addEventListener('pointerup',end); el.addEventListener('pointercancel',end); el.addEventListener('pointerleave',end);
      el.addEventListener('click',(e)=>{ if(moved>TH){ e.preventDefault(); e.stopPropagation(); } moved=0; },true);
    }

    prev?.addEventListener('click', () => gotoPage(nearestPageIndex() - 1));
    next?.addEventListener('click', () => gotoPage(nearestPageIndex() + 1));
    track.addEventListener('scroll', updateActiveDot, { passive: true });

    // ===== Init =====
    applyUniformCardWidth();
    PAGES = buildPages();
    gotoPage(0, 'auto');
    renderDots(0);

    // Ajustes por layout tardío
    requestAnimationFrame(() => {
      applyUniformCardWidth();
      PAGES = buildPages();
      gotoPage(nearestPageIndex(), 'auto');
      renderDots(nearestPageIndex());
    });
    setTimeout(() => {
      applyUniformCardWidth();
      PAGES = buildPages();
      gotoPage(nearestPageIndex(), 'auto');
      renderDots(nearestPageIndex());
    }, 250);

    enableDragScroll(track);

    // Recalcular en resize conservando la página
    const onResize = debounce(() => {
      const current = nearestPageIndex();
      applyUniformCardWidth();
      PAGES = buildPages();
      const idx = Math.max(0, Math.min(current, PAGES.length - 1));
      gotoPage(idx, 'auto');
      renderDots(idx);
    }, 120);

    window.addEventListener('resize', onResize, { passive: true });
    track.querySelectorAll('img').forEach(img => img.addEventListener('load', onResize, { once:true }));
  }

  function initSection(section){ setupTabs(section); }

  // Theme Editor hooks
  document.addEventListener('shopify:section:load', (e) => { if (e.target.matches(sectionSel)) initSection(e.target); });
  document.addEventListener('shopify:section:select', (e) => { if (e.target.matches(sectionSel)) initSection(e.target); });

  // DOM ready
  document.querySelectorAll(sectionSel).forEach(initSection);
})();

/* ===== Mobile: tabs scrolleables si hay + de 3 (sin barra visible) ===== */
(function () {
  const MOBILE_MAX_W = 990;
  const LIMIT = 3;

  function enableScrollableTabs(section) {
    const tabsRow = section.querySelector('.ctabs__tabs'); if (!tabsRow) return;
    const tabs = tabsRow.querySelectorAll('.ctabs__tab');
    const isMobile = window.matchMedia(`(max-width:${MOBILE_MAX_W}px)`).matches;
    if (!isMobile || tabs.length <= LIMIT) return;
    if (tabsRow.dataset.scrollReady === "1") return;
    tabsRow.dataset.scrollReady = "1";

    Object.assign(tabsRow.style, {
      overflowX:'auto', WebkitOverflowScrolling:'touch', display:'flex', flexWrap:'nowrap',
      scrollSnapType:'x proximity', gap:tabsRow.style.gap || '12px', paddingBottom:'4px'
    });
    tabs.forEach(btn => Object.assign(btn.style, { flex:'0 0 auto', whiteSpace:'nowrap', scrollSnapAlign:'start' }));
    tabsRow.setAttribute('role','tablist'); tabsRow.setAttribute('aria-orientation','horizontal');
    tabsRow.scrollLeft = 1;
    document.addEventListener('shopify:section:select', (e) => {
      if (e.target === section && window.matchMedia(`(max-width:${MOBILE_MAX_W}px)`).matches) tabsRow.scrollLeft = 0;
    });
  }

  function initAll(){ document.querySelectorAll('[data-section-type="collection-tabs"]').forEach(enableScrollableTabs); }
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (e) => { if (e.target.matches('[data-section-type="collection-tabs"]')) enableScrollableTabs(e.target); });
  let t; window.addEventListener('resize', () => { clearTimeout(t); t=setTimeout(initAll,150); }, { passive:true });
})();

/* ===== Fix: dots perfectamente redondos en Chrome ===== */
(function () {
  const DOTS_BTN = '.ctabs__dots button';
  function fixDot(btn){
    const w = btn.getBoundingClientRect().width || btn.offsetWidth || 11;
    const s = Math.round(w);
    btn.style.height = s+'px'; btn.style.minHeight = s+'px'; btn.style.maxHeight = s+'px';
    btn.style.borderRadius = Math.ceil(s/2)+'px';
    btn.style.padding='0'; btn.style.lineHeight='0'; btn.style.appearance='none'; btn.style.webkitAppearance='none';
    const h = btn.getBoundingClientRect().height || s; const ratio = h ? (w/h) : 1;
    if (Math.abs(1 - ratio) > 0.02) { btn.style.transformOrigin='50% 50%'; btn.style.transform = `scale(${ratio>1?1:ratio}, ${ratio>1?(1/ratio):1})`; }
    else if (btn.style.transform?.startsWith('scale(')) { btn.style.transform=''; }
  }
  function fixAll(scope=document){
    scope.querySelectorAll(DOTS_BTN).forEach((btn)=>{
      if (btn.dataset.circleFixed==='1') return; btn.dataset.circleFixed='1';
      const run=()=>fixDot(btn); requestAnimationFrame(run); setTimeout(run,120);
      new ResizeObserver(()=>fixDot(btn)).observe(btn);
    });
  }
  if (document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',()=>fixAll()); } else { fixAll(); }
  document.addEventListener('shopify:section:load',(e)=>{ if (e.target.matches('[data-section-type="collection-tabs"]')) fixAll(e.target); });
  document.addEventListener('ctabs:dots:rendered',(e)=>fixAll(e.detail?.panel||document));
  new MutationObserver((muts)=>{ for (const m of muts){ for (const n of m.addedNodes||[]){ if (n.nodeType===1){ if (n.matches?.(DOTS_BTN)) { fixAll(n.parentElement||n); return; } if (n.querySelector?.(DOTS_BTN)) { fixAll(n); return; } } } } }).observe(document.body,{childList:true,subtree:true});
  window.addEventListener('resize',()=>fixAll(),{passive:true});
})();

/* ===== Ocultar scrollbars horizontales en mobile (tabs y track) ===== */
(function(){
  const MOBILE_MAX_W = 990;

  // Inyecta CSS WebKit si aún no existe (para ocultar la barra)
  (function ensureCSS(){
    if (document.getElementById('ctabs-hide-scrollbar')) return;
    const st = document.createElement('style');
    st.id = 'ctabs-hide-scrollbar';
    st.textContent = '.hide-x-scrollbar::-webkit-scrollbar{display:none;width:0;height:0}';
    document.head.appendChild(st);
  })();

  function applyHideScrollbar(node){
    if (!node) return;
    node.classList.add('hide-x-scrollbar');
    node.style.scrollbarWidth = 'none';   // Firefox
    node.style.msOverflowStyle = 'none';  // IE/Edge legacy
    node.style.overflowX = node.style.overflowX || 'auto';
  }

  function onSection(section){
    const tabsRow = section.querySelector('.ctabs__tabs');
    const track   = section.querySelector('.ctabs__track');
    const isMobile = window.matchMedia(`(max-width:${MOBILE_MAX_W}px)`).matches;
    if (isMobile){ applyHideScrollbar(tabsRow); applyHideScrollbar(track); }
    else { tabsRow?.classList.remove('hide-x-scrollbar'); track?.classList.remove('hide-x-scrollbar'); }
  }

  function initAll(){ document.querySelectorAll('[data-section-type="collection-tabs"]').forEach(onSection); }
  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.matches('[data-section-type="collection-tabs"]')) onSection(e.target);
  });
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.matches('[data-section-type="collection-tabs"]')) onSection(e.target);
  });
  let t; window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(initAll, 120); }, { passive: true });
})();